import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

type MovieCardProps = {
  movie: Movie;
  compact?: boolean;
};

export default function MovieCard({ movie, compact = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden bg-primary-950">
        <div className="aspect-[3/4] w-full">
          <img
            src={movie.poster}
            alt={`${movie.title} 影视封面`}
            title={`${movie.title} - 剧情介绍与主演信息`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="absolute left-0 top-0 flex items-center gap-1 rounded-br-md bg-accent-500 px-2 py-1 font-label text-xs font-bold text-primary-950">
          <span className="flex h-3 w-3 items-center justify-center">
            <i className="ri-star-fill text-[11px]" />
          </span>
          {movie.rating.toFixed(1)}
        </div>
        <div className="absolute right-2 top-2 rounded-full bg-primary-950/70 px-2 py-1 text-[11px] text-background-50 backdrop-blur">
          {movie.type}
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-primary-950/90 via-primary-950/30 to-transparent px-3 pb-2 pt-8">
          <p className="line-clamp-1 text-[11px] text-background-100/90">{movie.tagline}</p>
        </div>
      </div>

      <div className={`flex flex-1 flex-col ${compact ? "p-3" : "p-4"}`}>
        <div className="flex items-start justify-between gap-2">
          <h3 className={`font-semibold text-foreground-950 transition-colors group-hover:text-primary-600 ${compact ? "text-sm" : "text-base"}`}>
            {movie.title}
          </h3>
          <span className="mt-0.5 shrink-0 font-label text-[11px] text-foreground-500">{movie.year}</span>
        </div>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-600">
          {movie.region} · {movie.genres.slice(0, 2).join(" / ")}
        </p>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-500">主演：{movie.cast.slice(0, 2).join("、")}</p>
        {!compact && (
          <p className="mt-2 line-clamp-2 text-xs leading-6 text-foreground-600">{movie.summary}</p>
        )}
        <div className="mt-3 flex flex-wrap items-center gap-1.5">
          {movie.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}